import { useContext, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import authContext from "../../../../AuthContext/authContext";
import appActions from "../../../../ReduxStore/appDataSlice";
import Home from "../Home/Home";
import Table from "../../Table/Table";
import classes from "../../Table/Table.module.css";
import axios from "axios";
import { toast } from "react-toastify";
const base_url = process.env.REACT_APP_BASE_URL;
const moment = require("moment");

//&& (row.passType === "PreBooking" ? new Date(row.createdForDate) >= new Date() : new Date(row.createdAt) >= new Date(new Date() - 24 * 60 * 60 * 1000))
const VisitorWrapper = () => {
  const activeCompany = useSelector((state) => state.appData.activeCompany);
  const activeLocation = useSelector((state) => state.appData.activeLocation);
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const ctx = useContext(authContext);
  const userName = ctx?.userDetailedData?.name;
  // console.log("Context value in visitor wrapper", ctx);
  const userType = ctx.userData.user_type;
  const sortDirection = useSelector((state) => state.appData.sortDirection);
  const [isLoading, setIsloading] = useState(false);
  const dateSort = (rowA, rowB) => {
    dispatch(appActions.setSortDirection(sortDirection === "1" ? "-1" : "1"));
    localStorage.setItem("sortDirection", sortDirection === "1" ? "-1" : "1");
  };

  const isHidden = userType == "admin" || userType == "subadmin";

  const maskText = (text) => {
    text = String(text);
    if (text.length <= 2) {
      return "*".repeat(text.length);
    }
    const maskedText = text.slice(0, 3) + "*".repeat(text.length - 3);
    return maskedText;
  };

  const handleApproveReject = (Id, status, empName, phone, currentStatus) => {
    if (currentStatus !== "pending") {
      return;
    }
    setIsloading(true);
    let reqObj = {
      method: "POST",
      url: `${base_url}/visitor/emp-decision`,
      headers: {
        "Content-Type": "application/json"
      },
      data: {
        visitorId: Id,
        status: status
      }
    };
    axios(reqObj)
      .then((res) => {
        toast.success(`Successfully ${status} request`);
        setIsloading(false);
      })
      .catch((err) => {
        console.log(err);
        toast.error(`Failed to update`);
        setIsloading(false);
      });
    // /visitor/end-meeting
    if (status == "rejected") {
      axios
        .put(`${base_url}/visitor/check-out/${Number(phone)}`, {
          checkedoutBy: `${userName}(Admin)`
        })
        .then((visitor) => {});
    }
  };

  const approveAll = (isEmpty, status) => {
    setIsloading(true);
    if (isEmpty == "empty") {
      toast.dismiss();
      toast.error("There are no visitors");
      setIsloading(false);
      return;
    }

    let data = {
      status: status,
      companyId: activeCompany["_id"]
    };
    if (activeLocation) {
      if (activeLocation["_id"] !== "All") {
        data.locationId = activeLocation["_id"];
      }
    }
    let reqObj = {
      method: "PUT",
      url: `${base_url}/visitor/approve-all`,
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${ctx.token}`
      },
      data: data
    };

    axios(reqObj)
      .then((res) => {
        toast.dismiss();
        toast.success(`Request ${status} for all visitors`);
        setIsloading(false);
      })
      .catch((err) => {
        console.log(err);
        toast.dismiss();
        toast.error(
          err.response.data.error.message || `Failed to set status to ${status}`
        );
        setIsloading(false);
      });
  };

  const columns = [
    {
      id: "srNo",
      name: "Visitor ID",
      cell: (row, index) => row._id
    },
    {
      id: "passType",
      name: "Pass Type",
      selector: (row) => {
        if (row.passType == "Delegate" || row.passType == "Vendor") {
          return row.passType;
        } else {
          if (row.passType == "PreBooking"){
            return 'APPOINTMENT';
          } else {
            return row.passType;
          }
        }
      },
      sortable: false
      // sortFunction: dateSort,
    },
    {
      id: "date",
      name: "Request Date & Time",
      selector: (row) => {
        if(row.passType=="PreBooking"){
          console.log(row.visitingDate);
          if (row.visitingDate) {
            return moment(row.visitingDate).format("MMM D, hh:mm A");
          }
          return 'N/A';
        } 
        return moment(row.createdAt).format("MMM D, hh:mm A");
      },
      sortable: false,
      sortFunction: dateSort
    },
    { 
      name: "User/Company Name",
      selector: (row) => {
        // isHidden
        // ? maskText(`${row.firstName}-${row.companyName}`)
        // : `${row.firstName}-${row.companyName}`,
        if (row.firstName && row.companyName) {
          if (isHidden) {
            return maskText(`${row.firstName}-${row.companyName}`);
          } else {
            return `${row.firstName}-${row.companyName}`;
          }
        } else {
          if (isHidden) {
            return maskText(`${row.firstName}`);
          } else {
            return `${row.firstName}`;
          }
        }
      },

      sortable: true
    },
    {
      name: "Meeting Person/Designation",
      selector: (row) => {
        console.log("row", row);
        if (row.empName || row.empDesignation) {
          return `${row.empName ? row.empName : ""} ${
            row.empDesignation ? "-" + row.empDesignation : ""
          }`;
        } else {
          return "NA";
        }
      },
      // row.empDesignation == "undefined"
      //   ? `${row.empName}`
      //   : `${row.empName}-${row.empDesignation}`,
      sortable: true
    },
    {
      name: "Location",
      selector: (row) => (isHidden ? maskText(row.location) : row.location),
      sortable: true
    },
    {
      name: "Meeting Purpose",
      selector: (row) => (row.purposeOfVisit ? row.purposeOfVisit : "NA"),
      sortable: true
    },
    {
      name: "Status",
      selector: (row) => row.status,
      sortable: true
    },
    {
      name: "Action",
      cell: (row) => (
        
        <div style={{ display: 'flex', gap: '5px' }}> 
        {console.log(row,"row")}
          {row.status === "pending" ? (
            <>
              <button
                className="btn btn-success btn-sm"
                onClick={() =>
                  handleApproveReject(
                    row._id,
                    "approved",
                    row.empName,
                    row.phone,
                    row.status
                  )
                }
              >
                Approve
              </button>
              <button
                className="btn btn-danger btn-sm"
                onClick={() =>
                  handleApproveReject(
                    row._id,
                    "rejected",
                    row.empName,
                    row.phone,
                    row.status
                  )
                }
              >
                Reject
              </button>
            </>
          ) : row.status === "approved"  ? (
            <button
            style={{
              backgroundColor: "blue",
              color: "white",
              border: "none",
              padding: "5px 10px",
              cursor: "pointer",
              borderRadius: "5px",
              transition: "background-color 0.3s ease",
            }}
            onClick={async (event) => {
              const button = event.currentTarget;
              const originalText = button.innerHTML;
              button.innerHTML = '<span>Loading...</span>';
              button.disabled = true;
          
              try {
                // Create a hidden iframe
                const iframe = document.createElement('iframe');
                iframe.style.position = 'fixed';
                iframe.style.width = '0';
                iframe.style.height = '0';
                iframe.style.border = 'none';
                document.body.appendChild(iframe);
          
                // Add print styles
                const style = document.createElement('style');
                style.id = 'print-styles';
                style.textContent = `
                  @page {
                    size: auto;
                    margin: 0;
                  }
                  body {
                    margin: 0;
                    padding: 0;
                    display: flex;
                    justify-content: center;
                    align-items: center;
                    min-height: 100vh;
                    background: white !important;
                  }
                  .print-container {
                    display: flex;
                    justify-content: center;
                    align-items: center;
                    width: 100%;
                    padding: 20px;
                    box-sizing: border-box;
                  }
                  .id-card {
                    transform: scale(1.5);
                    transform-origin: center center;
                    box-shadow: none !important;
                    border: 1px solid #ddd !important;
                    margin: 0 auto !important;
                  }`;
                document.head.appendChild(style);
          
                // Handle iframe load
                iframe.onload = () => {
                  try {
                    const iframeDoc = iframe.contentDocument || iframe.contentWindow.document;
                    
                    // Add print styles to the iframe
                    const iframeStyle = iframeDoc.createElement('style');
                    iframeStyle.textContent = `
                      @page {
                        size: auto;
                        margin: 0;
                      }
                      body {
                        margin: 0;
                        padding: 0;
                        display: flex;
                        justify-content: center;
                        align-items: center;
                        min-height: 100vh;
                        background: white !important;
                      }
                      .print-container {
                        display: flex !important;
                        justify-content: center !important;
                        align-items: center !important;
                        width: 100% !important;
                        min-height: 100vh !important;
                        padding: 20px !important;
                        box-sizing: border-box !important;
                      }`;
                    iframeDoc.head.appendChild(iframeStyle);
          
                    // Focus and print
                    setTimeout(() => {
                      if (iframe.contentWindow) {
                        iframe.contentWindow.focus();
                        iframe.contentWindow.print();
                      }
                      // Clean up after printing
                      setTimeout(() => {
                        if (iframe.parentNode) document.body.removeChild(iframe);
                        const styles = document.getElementById('print-styles');
                        if (styles) document.head.removeChild(styles);
                        button.innerHTML = originalText;
                        button.disabled = false;
                      }, 1000);
                    }, 5000);
                  } catch (error) {
                    console.error('Print error:', error);
                    toast.error('Error printing document');
                    if (iframe.parentNode) document.body.removeChild(iframe);
                    const styles = document.getElementById('print-styles');
                    if (styles) document.head.removeChild(styles);
                    button.innerHTML = originalText;
                    button.disabled = false;
                  }
                };
          
                // Set iframe source
                iframe.src = `/print/${row._id}`;
          
                // Handle iframe error
                iframe.onerror = () => {
                  toast.error('Failed to load the print document');
                  if (iframe.parentNode) document.body.removeChild(iframe);
                  const styles = document.getElementById('print-styles');
                  if (styles) document.head.removeChild(styles);
                  button.innerHTML = originalText;
                  button.disabled = false;
                };
              } catch (error) {
                console.error('Error:', error);
                toast.error('An error occurred');
                const button = event.currentTarget;
                button.disabled = false;
                const styles = document.getElementById('print-styles');
                if (styles) {
                  document.head.removeChild(styles);
                }
              }
            }}
            >
              <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" viewBox="0 0 16 16">
                <path d="M5 1a2 2 0 0 0-2 2v1h10V3a2 2 0 0 0-2-2H5zm6 8H5a1 1 0 0 0-1 1v3a1 1 0 0 0 1 1h6a1 1 0 0 0 1-1v-3a1 1 0 0 0-1-1z" />
                <path d="M0 7a2 2 0 0 1 2-2h12a2 2 0 0 1 2 2v3a2 2 0 0 1-2 2h-1v-2a2 2 0 0 0-2-2H5a2 2 0 0 0-2 2v2H2a2 2 0 0 1-2-2V7zm2.5 1a.5.5 0 1 0 0-1 .5.5 0 0 0 0 1z" />
              </svg>
              Print
            </button>
          ) : (
            <span>NA</span>
          )}
        </div>
      ),
      width: "200px"
    }
  ];

  let showCsvExport = false;
  let showDownload = true;
  let showExport = false;
  let showLocation = true;
  let showSms = true;
  let showAddNew = false;
  let showFirstHr = false;
  let showSecondHr = false;
  let showActions = true;
  let showActiveVisitors = true;

  if (
    userType === "Company Manager" ||
    userType === "location" ||
    userType === "Building Manager"
  ) {
    showCsvExport = false;
    showDownload = true;
    showExport = false;
    showLocation = false;
    showSms = false;
    showAddNew = false;
    showFirstHr = false;
    showSecondHr = false;
    showActions = true;
  }
  if (userType === "Building Manager") {
    showLocation = true;
  }

  if (userType == "subadmin") {
    showDownload = false;
    showActiveVisitors = false;
  }

  if (userType == "admin") {
    showActiveVisitors = false;
  }

  if (userType === "guard") {
    showAddNew = false;
    showCsvExport = false;
    showDownload = false;
    showExport = false;
    showLocation = false;
    showSms = false;
    showFirstHr = false;
    showSecondHr = false;
    showActions = false;
    showActiveVisitors = false;

  }

  const options = {
    title: "Visitor",
    showCsvExport: showCsvExport,
    showDownload: showDownload,
    showExport: showExport,
    showLocation: showLocation,
    showSms: showSms,
    showAddNew: showAddNew,
    showFirstHr: showFirstHr,
    showSecondHr: showSecondHr,
    showActions: showActions,
    showActiveVisitors: showActiveVisitors,
    type: "Visitor",
    columns: columns,
    apiUrl: `${base_url}/visitor/list`,
    companyId: activeCompany._id, //for building company Id and Building Id is same
    locationId: userType === "location" ? activeLocation._id : ""
  };
  return (
    <>
      <Home
        propComponent={
          <Table
            options={options}
            approveAll={approveAll}
            isLoading={isLoading}
          />
        }
      />
    </>
  );
};

export default VisitorWrapper;
